export * from './lib/app-go-shell-feature.module';
